import React, { useState, useMemo } from 'react';
import TopBarChartComponent from './BarChartComponent';
import CustomPieChart from './PieChartComponent';
const ProductCharts = ({ company_info }) => {
  const [selectedOption, setSelectedOption] = useState('Suppliers');

  return (
    <div className="w-full max-w-3xl border rounded-lg shadow-sm">
      <div className="flex flex-row items-center justify-between p-4 border-b">
        <h2 className="text-lg font-medium flex items-center"> 
          <select 
            value={selectedOption} 
            onChange={(e) => setSelectedOption(e.target.value)}
            className="ml-2 p-1 border rounded text-primary-600 font-medium"
            style={{color: '#0f73be', backgroundColor: '#dddddd', fontWeight: 'bold'}}
          >
            <option value="Suppliers">Supplied</option>
            <option value="Customers">Acquired</option>
          </select>
          <span
            style={{color: '#0f73be',fontWeight: 'bold'}}          >
            Products 
          </span>
        </h2>
      </div>
      <div className="p-4">
        {
            selectedOption !== 'Suppliers' ?
            CustomPieChart(company_info?.data?.top_acquired_products) :
            CustomPieChart(company_info?.data?.top_supplied_products)
        }
      </div>
    </div>
  );
};

export default ProductCharts;